import request from '@/utils/request'
import { v2Host } from '@/config/host'

// news 新闻接口
// http://playable.dev.com:8067/?doc=website/news.go

// 创建
export function creatNews(data) {
  return request({
    url: `${v2Host}/website/news/create`,
    method: 'post',
    data: data
  })
}

// 删除
export function deleteNews(id, data) {
  return request({
    url: `${v2Host}/website/news/delete?id=${id}`,
    method: 'post',
    data: data
  })
}

// 发布
export function publishNews(id, data) {
  return request({
    url: `${v2Host}/website/news/publish?id=${id}`,
    method: 'post',
    data: data
  })
}

// 更新
export function updateNews(id, data) {
  return request({
    url: `${v2Host}/website/news/update?id=${id}`,
    method: 'post',
    data: data
  })
}

export function fetchNewsList(params) {
  return request({
    url: `${v2Host}/website/news/list`,
    method: 'get',
    params: params
  })
}

export function fetchNewsInfo(id, params) {
  return request({
    url: `${v2Host}/website/news/info?id=${id}`,
    method: 'get',
    params: params
  })
}
